/**
 * This module is to manage the preloaders display.
 * Based on the message bus comunication this module functionality should't be called from the outside
 *
 * @module app/components/PreLoaderManager
 */
import _ from 'lodash';
import DeviceDetector from './DeviceDetector';
import jQuery from 'jquery';
import URLProvider from './URLProvider';
import MessageBusTopics from '../../common/MessageBusTopics';

var contentarea = {
    querySelector: '#contentarea',
};

var overlay = {
    querySelector: '#wh-global-overlay',
    toggleClass: 'wh-hide',
};

var errorlayer = {
    querySelector: '#error404',
    toogleClass: 'wh-show',
};

var seoContainer = {
    querySelector: '.seo-container',
};

const nonExistingPage = {
    querySelector: '.page-not-found',
};

/**
 * This object contains definitios for all the warnings to be displayed
 *
 * @type {Object}
 *
 * @private
 */
var warnings = {

    first: {
        timeout: null,
        timeoutDelay: 5000,
        toggleClass: 'wh-preloader-container--stage-2',
        querySelector: '#wh-preloader',
    },

    second: {
        timeout: null,
        timeoutDelay: 20000,
        toggleClass: 'wh-preloader-container--stage-3',
        querySelector: '#wh-preloader',
    },

};

/**
 * Object containing all the possible operations received by the messagebus to be perform
 * Any operation not included in this object will be skipped.
 *
 * @type {Object}
 *
 * @private
 */
var operations = {


    fullPage: {

        /**
         * Keeps a count of how many guys are requesting this module so we can avoid canceling it before
         * expected
         *
         * @type {Integer}
         *
         * @private
         */
        counter: 0,

        /**
         * This method will canncel the full page loader.
         *
         * @returns {void}
         *
         * @type    {Function}
         *
         * @private
         */
        cancel: function cancel() {

            operations.fullPage.counter = 0;
            jQuery(overlay.querySelector)
                .toggleClass(overlay.toggleClass, true);
            stopAllTimeouts();
            hideAllWarnings();
        },

        /**
         * This method will try to canncel the full page loader. First it will check if
         * the status is correct and the counter is 0
         *
         * @param   {Boolean}   status  To add or not the toggle class bound to this element
         *                              true = show, false = hide
         *
         * @returns {void}
         *
         * @type    {Function}
         *
         * @private
         */
        tryCanceling: function tryCanceling(status) {

            if (!status && operations.fullPage.counter === 0) {

                operations.fullPage.cancel();
            }
        },

        /**
         * This method updates the counter of messages trying to expose the same full page loader
         * This will be based on the desired status (show hide)
         *
         * @param   {Boolean}   status  To add or not the toggle class bound to this element
         *                              true = show, false = hide
         *
         * @returns {void}
         *
         * @type    {Function}
         *
         * @private
         */
        updateCounter: function updateCounter(status) {

            operations.fullPage.counter += (status) ? 1 : -1;

            //this guarantees counter is not lower than 0
            operations.fullPage.counter = Math.max(0, operations.fullPage.counter);
        },

        /**
         * This function will change the visibility of the main loader.
         * The operation is trigger from a message bus notification on the function name as key.
         *
         * @param   {Boolean}   status  To add or not the toggle class bound to this element
         *                              true = show, false = hide
         *
         * @returns {void}
         *
         * @type    {Function}
         *
         * @private
         */
        handler: function fullPageOperationHandler(status) {

            operations.fullPage.updateCounter(status);

            if (status && operations.fullPage.counter === 1) {

                showMain();

                jQuery(overlay.querySelector)
                    .toggleClass(overlay.toggleClass, false);

                startAllTimeouts();
            } else {

                operations.fullPage.tryCanceling(status);
            }
        },
    },

    fullPageError: {

        /**
         * This function changes the visibility. It hides the loader and
         * displays the error for de full page loader
         *
         *
         * @returns {void}
         *
         * @private
         */
        handler: function fullPageError() {
            let nodesToHide = seoContainer.querySelector;

            operations.fullPage.cancel();

            if (!jQuery(nonExistingPage.querySelector).length) {
                nodesToHide = [nodesToHide, contentarea.querySelector].join(', ');
                jQuery(errorlayer.querySelector)
                    .removeClass('wh-hide')
                    .addClass('wh-show');
            }

            jQuery(nodesToHide).addClass('wh-hide');

        },
    },
};

/**
 * Helper to show main box and hide error404 layer
 *
 * @returns {void}
 *
 * @private
 */
const showMain = function showMain() {
    let nodesToShow = contentarea.querySelector;

    jQuery(errorlayer.querySelector)
        .removeClass('wh-show')
        .addClass('wh-hide');


    if (!jQuery(nonExistingPage.querySelector).length) {
        nodesToShow = [nodesToShow, seoContainer.querySelector].join(', ');
    }

    jQuery(nodesToShow).removeClass('wh-hide');
};

/**
 * Removes the classes which apply the skeleton image on initial page load and restores the regular loader
 * @returns {void}
 * @private
 */
var removeSkeleton = function removeSkeleton() {
    const overlay = jQuery('#skeleton-overlay');
    if (overlay.length) {
        jQuery('#main-container').removeClass('skeleton-hide');
        overlay.remove();
    }
};

/**
 * This function will show an specific warning
 *
 * @return {void}
 *
 * @private
 */
var displayWarning = function displayWarning(warning) {

    hideAllWarnings();
    publishWarningDisplayId(warning.index);
    var warningContent = warning.content;
    jQuery(warningContent.querySelector).toggleClass(warningContent.toggleClass, true);
};

var publishWarningDisplayId = function publishWarningDisplayId(index) {
    window.WH.messageBus.publish(MessageBusTopics.WARNING_DISPLAYED, { displayed: index });
};

/**
 * This function will hide an specific warning
 *
 * @return {void}
 *
 * @private
 */
var hideWarning = function hideWarning(warning) {

    jQuery(warning.querySelector).toggleClass(warning.toggleClass, false);
};


/**
 * This function will hide all the warnings
 *
 * @return {void}
 *
 * @private
 */
var hideAllWarnings = function hideAllWarnings() {

    _.each(warnings, function startWarningsLoop(warning) {

        hideWarning(warning);
    });
};

/**
 * This function will start all the warning timeouts
 *
 * @return {void}
 *
 * @private
 */
var startAllTimeouts = function startAllTimeouts() {

    stopAllTimeouts();

    _.each(warnings, function startWarningsLoop(warning, index) {
        warning.timeout = window.setTimeout(
            displayWarning,
            warning.timeoutDelay,
            { content: warning, index: index });
    });
};

/**
 * This function will stop all the warning timeouts
 *
 * @return {void}
 *
 * @private
 */
var stopAllTimeouts = function stopAllTimeouts() {

    _.each(warnings, function startWarningsLoop(warning) {

        window.clearTimeout(warning.timeout);
        warning.timeout = null;
    });

};

/**
 * This will make this module start listening to the message bus in order to receive actions to be
 * sent to the native app through the tunnel.
 *
 * @returns {void}
 *
 * @private
 */
var subscribeToMessageBus = function subscribeToMessageBus() {

    window.WH.messageBus.subscribe(MessageBusTopics.PRELOADER_TOPIC, processMessage);
    window.WH.messageBus.subscribe(MessageBusTopics.REMOVE_WEB_SKELETON_OVERLAY, removeSkeleton);
};

/**
 * This method will try to stract an operation received from the message bus and a data attached
 * to trigger an action to communicate with the native app.
 *
 * @param       {Object}    message  Communication key
 * @param       {Object}    data     Object containing operation + data keys
 *
 * @returns     {void}
 *
 * @private
 */
var processMessage = function processMessage(message, data) {
    if (data && data.operation && operations.hasOwnProperty(data.operation)) {
        operations[data.operation].handler(data.data);
    }
};

/**
 * Event handler for reload click button
 *
 * @returns {void}
 *
 * @private
 */
var onReloadButton = function onReloadButton() {

    // Translation: dont translate this as homepage does not contain any localised parts
    var target = URLProvider.homepage.base({
        locale: (window.WH && window.WH.sportsbook && window.WH.sportsbook.lang) ?
            window.WH.sportsbook.lang : 'en-gb',
    });

    setTimeout(
        function () {
            window.location = target;
        },
        window.WH.sportsbook.pageReloadDelay
    );
};

/**
 * This function initializes the communication with the native app
 *
 * @returns {void}
 *
 * @public
 */
var init = function init() {
    subscribeToMessageBus();
    jQuery(overlay.querySelector)
        .off('click.reloadButton')
        .on('click.reloadButton', '.wh-preloader-container__btn', onReloadButton);
};


init();
